export default function Dashboard({
  missions = [],
  stats = {},
  equipment = [],
  roster = [],
  onCreateMission,
  onOpenMission,
  setNav
}) {
  const activeOps = missions.filter((op) =>
    ["Planning", "Approved", "Active"].includes(op.status)
  );

  const criticalOps = missions.filter((op) => op.priority === "Critical");
  const readyOperators = roster.filter((op) => op.status === "Available").length;
  const rosterTotal = roster.length || 0;
  const equipmentPct = Number(stats.equipmentPct ?? 100);

  const statItems = [
    {
      label: "Active Ops",
      value: stats.active ?? activeOps.length,
      sub: "Planning / approved / active",
      tone: "blue",
      nav: "operations"
    },
    {
      label: "Critical Priority",
      value: stats.critical ?? criticalOps.length,
      sub: "Critical operations",
      tone: "red",
      nav: "operations"
    },
    {
      label: "Operators Ready",
      value: readyOperators,
      sub: `${rosterTotal} total rostered`,
      tone: "green",
      nav: "roster"
    },
    {
      label: "Equipment Ready",
      value: `${equipmentPct}%`,
      sub: "Readiness status",
      tone: equipmentPct >= 90 ? "green" : equipmentPct >= 75 ? "gold" : "red",
      nav: "equipment"
    },
    {
      label: "AAR Due",
      value: stats.aarDue ?? 0,
      sub: "Debrief / review needed",
      tone: "gold",
      nav: "aars"
    }
  ];

  return (
    <section>
      <div className="dashboard-hero">
        <div>
          <div className="eyebrow">Operational Overview</div>
          <h2>Command Dashboard</h2>
          <p className="muted">
            Current operations, readiness status, roster availability, and pending reviews.
          </p>
        </div>

        <div className="dashboard-actions">
          <button className="primary" onClick={onCreateMission}>
            Create Operation
          </button>
          <button onClick={() => setNav("live")}>
            Live Operations
          </button>
        </div>
      </div>

      <div className="dashboard-rings">
        {statItems.map((item) => (
          <button
            key={item.label}
            className={`dashboard-ring-card tone-${item.tone}`}
            onClick={() => item.nav && setNav(item.nav)}
          >
            <span className="ring-glow" />
            <span className="ring-value">{item.value}</span>
            <span className="ring-label">{item.label}</span>
            <span className="ring-sub">{item.sub}</span>
          </button>
        ))}
      </div>

      <div className="dashboard-grid">
        <div className="panel">
          <div className="section-head">
            <div>
              <h2>Active Operations</h2>
              <p className="muted">Operations currently moving through the lifecycle.</p>
            </div>
            <button onClick={() => setNav("operations")}>Open Board</button>
          </div>

          <div className="mission-list compact">
            {activeOps.slice(0, 5).map((op) => (
              <div className="mission-card" key={op.id}>
                <div className="mission-main">
                  <div className="mission-title">{op.title}</div>
                  <div className="mission-meta">
                    {(op.operationType || op.missionType || "Operation")} • {op.location || "No location"} • {op.status}
                  </div>
                  <div className="chips">
                    <span className={`badge ${op.priority === "Critical" ? "danger" : op.priority === "High" ? "warn" : "neutral"}`}>
                      {op.priority}
                    </span>
                    <span className="badge neutral">Cmd: {op.commander || "TBD"}</span>
                  </div>
                </div>

                <div className="mission-actions">
                  <button onClick={() => onOpenMission(op)}>Open</button>
                </div>
              </div>
            ))}

            {activeOps.length === 0 ? (
              <div className="empty">No active operations.</div>
            ) : null}
          </div>
        </div>

        <div className="panel">
          <div className="section-head">
            <div>
              <h2>Readiness Snapshot</h2>
              <p className="muted">Equipment and personnel readiness overview.</p>
            </div>
          </div>

          <div className="readiness-stack">
            {equipment.slice(0, 6).map((item) => {
              const pct = item.total
                ? Math.round((Number(item.ready || 0) / Number(item.total || 1)) * 100)
                : 100;

              return (
                <div className="readiness-row" key={item.id}>
                  <div>
                    <b>{item.name}</b>
                    <small>{item.category} • {item.status}</small>
                  </div>

                  <div className="progress-wrap">
                    <div className="progress">
                      <span style={{ width: `${pct}%` }} />
                    </div>
                    <strong>{pct}%</strong>
                  </div>
                </div>
              );
            })}
          </div>

          <button onClick={() => setNav("equipment")}>
            Open Equipment Readiness
          </button>
        </div>
      </div>
    </section>
  );
}
